/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {PartNumberChangesDetailTitleComponent} from './part-number-changes-detail-title.component';

@NgModule({
    declarations: [PartNumberChangesDetailTitleComponent],
    exports: [
        PartNumberChangesDetailTitleComponent
    ]
})
export class PartNumberChangesDetailTitleModule {
}
